import { generateRandomString } from '@/helpers/common';

export default {
  SET_TOKEN(state, token) {
    if (token) {
      localStorage.setItem('token', generateRandomString(10) + btoa(token));
      state.token = token;
    } else {
      localStorage.removeItem('token');
      state.token = null;
    }
  },
  SET_BIOMETRIC_TOKEN(state, biometricToken) {
    if (biometricToken) {
      localStorage.setItem('biometricToken', generateRandomString(10) + btoa(biometricToken));
    } else {
      localStorage.removeItem('biometricToken');
    }
    state.biometricToken = biometricToken;
  },
  SET_REFRESH_TOKEN(state, refreshToken) {
    if (refreshToken) {
      localStorage.setItem('refreshToken', generateRandomString(10) + btoa(refreshToken));
    } else {
      localStorage.removeItem('refreshToken');
    }
    state.refreshToken = refreshToken;
  },
  SET_INFOR(state, infor) {
    state.infor = { ...state.infor, ...infor };
  },
  SET_AUTHENTICATION_TOKEN(state, authenticationToken) {
    state.authenticationToken = authenticationToken;
    sessionStorage.setItem('authenticationToken', authenticationToken);
  },
  RESET_AUTHENTICATION_TOKEN(state) {
    state.authenticationToken = null;
    state.maximumAmount = null;
    sessionStorage.removeItem('authenticationToken');
    sessionStorage.removeItem('maximumAmount');
    sessionStorage.removeItem('registId');
  },
  SET_MAXIMUM_AMOUNT(state, maximumAmount) {
    state.maximumAmount = maximumAmount;
    sessionStorage.setItem('maximumAmount', maximumAmount);
  },
  RESET_INFOR(state) {
    state.infor = {};
  },
  RESET_AUTH(state) {
    state.infor = {};
    state.token = null;
    state.refreshToken = null;
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  },
  SET_LINKAGE_TOKEN(state, token) {
    if (token) {
      localStorage.setItem('token', token);
      state.token = token;
    } else {
      localStorage.removeItem('token');
      state.token = null;
    }
  },
  SET_REFRESH_LINKAGE_TOKEN(state, refreshToken) {
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken);
    } else {
      localStorage.removeItem('refreshToken');
    }
    state.refreshToken = refreshToken;
  },
};
